import { Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";

const NetworkCheck = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  return (
    <Transition
      show={!isOnline}
      enter="transition-opacity duration-100"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 w-full h-screen flex items-center justify-center bg-extraLightGray bg-opacity-40 backdrop-blur-sm z-[9999]">
        <section className="bg-white w-4/12 px-4 py-10 rounded-md shadow-lg flex flex-col text-center items-center justify-center border border-extraLightGray">
          <ExclamationCircleIcon className="h-20 w-20 text-body" />
          <h1 className="text-xl font-semibold text-gray">Network Error</h1>
          <p className="text-base text-subheading font-medium">
            It seems that you are offline. Please check your internet connection
            and try again.
          </p>
        </section>
      </div>
    </Transition>
  );
};

export default NetworkCheck;
